import { Component, EventEmitter, inject, Input, OnInit, Output, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { takeUntil, take } from "rxjs/operators";
import { Method, PaymentType, PayMethodDetail } from "@modules/employee-data/types/accounts";
import { PayElectiveCommonService } from "@modules/employee-data/services/pay-elective-common.service";
@Component({
	selector: "app-pay-elective-inactive-payment-methods-list",
	templateUrl: "./pay-elective-inactive-payment-methods-list.component.html",
	styleUrls: ["./pay-elective-inactive-payment-methods-list.component.scss"]
})
export class PayElectiveInactivePaymentMethodsListComponent implements OnInit, OnDestroy {
	payElectiveCommonService = inject(PayElectiveCommonService);

	@Input() inactivePaymentMethods!: Observable<PayMethodDetail[]>;
	@Input() providerName!: string;
	@Input() payGroupId!: string;

	net: PaymentType = PaymentType.NET;
	ewa: PaymentType = PaymentType.EWA;
	ttp: PaymentType = PaymentType.TPP;

	private destroy$ = new Subject<void>();

	@Output() toggleCreatingBankAccountEvent$ = new EventEmitter<any>();
	@Output() editBankAccountEvent$ = new EventEmitter<{ accountId: string; payMethodsLength: number }>();

	inactivePaymentMethodsArray!: PayMethodDetail[];
	cpNowIntegrationEnabled = false;
	paygroupCPNowToggleOn = false;

	ngOnInit(): void {
		this.inactivePaymentMethods.pipe(takeUntil(this.destroy$)).subscribe(data => {
			this.inactivePaymentMethodsArray = data;

			this.inactivePaymentMethodsArray.forEach((item, index) => {
				let customPaymentField;
				customPaymentField = item.details?.fields?.filter(
					field => field.key === "ACCOUNT_NUMBER" || field.key === "CARD_NUMBER"
				)[0];

				if (!customPaymentField?.value) {
					customPaymentField = item.details?.fields?.filter(field => field.key === "IBAN")[0];
				}

				this.inactivePaymentMethodsArray[index] = {
					...this.inactivePaymentMethodsArray[index],
					customPaymentField
				};
			});
		});

		this.checkCPNowIntegrationFeature();
	}

	onClickEditBankAccount(accountId: string, payMethodsLength: number): void {
		this.editBankAccountEvent$.emit({ accountId: accountId, payMethodsLength: payMethodsLength });
	}

	onClickToggleCreatingBankAccount(): void {
		this.toggleCreatingBankAccountEvent$.emit("toggle");
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	getPayMethodStatusName(payMethod: Method): string {
		return payMethod.status?.name;
	}

	payMethodStatusClass(payMethod: Method): {} {
		const statuses = ["created", "active", "inactive", "processing"];

		return statuses.includes(payMethod.status?.name.toLowerCase())
			? { [payMethod.status?.name.toLowerCase()]: true }
			: {};
	}

	private checkCPNowIntegrationFeature(): void {
		this.payElectiveCommonService
			.isCPNowIntegrationEnabled(this.payGroupId)
			.pipe(take(1))
			.subscribe(hasFeature => {
				this.cpNowIntegrationEnabled = hasFeature;
			});

		this.payElectiveCommonService
			.getPayGroupCached(this.payGroupId)
			.pipe(take(1))
			.subscribe(payGroup => {
				this.paygroupCPNowToggleOn = payGroup.data?.cloudPayNow ?? false;
			});
	}
}
